import { store } from '@/store';
import { ICallback } from './message_handlers/callback';
import { add_catalog, remove_catalog, update_catalog } from './message_handlers/catalog';
import { jump_to } from "./message_handlers/jumpt_to";
import { add_fits, remove_fits, update_fits } from './message_handlers/fits';
import { sync_from_kernel } from "./message_handlers/sync_from_kernel";
import { snapshot } from "./message_handlers/snapshot";
import { add_polygon, remove_polygon } from "./message_handlers/polygon";
import { postage_stamp } from "./message_handlers/postage_stamp";
import { safeOrigin } from './safeOrigin';
import { StateLink, registerBasicLinks } from './StateLink';

export function setupJupyter() {
  window.addEventListener('message', (ev) => {
    Bridge.fromMessage(ev)
  })
}

const handlers = {
  jump_to, snapshot,
  add_catalog, remove_catalog, update_catalog,
  add_fits, remove_fits, update_fits,
  sync_from_kernel,
  add_polygon, remove_polygon,
  postage_stamp,
}

type IMessageFromKernel = Parameters<typeof handlers[keyof (typeof handlers)]>[1]

export class Bridge {
  constructor(readonly port: MessagePort) {
    port.onmessage = (ev2: MessageEvent) => {
      this.processMessage(ev2.data)
    }
    for (const k of Object.keys(Bridge.stateLinks)) {
      const stateLink = new Bridge.stateLinks[k](this)
      this.stateLinks[k] = stateLink
    }
  }

  stateLinks: { [name: string]: StateLink } = {}

  processMessage(msg: IMessageFromKernel) {
    if (msg.type in handlers) {
      const h = handlers[msg.type]
      // @ts-ignore
      h(this, msg)
    } else {
      alert(`Unknown message type: ${msg.type}`)
    }
  }

  get globe() {
    return store.currentGlobe()
  }

  get jupyterGlobe() {
    return store.globe(store.jupyterFrame!)!
  }

  callback(cb: ICallback, args: any[]) {
    // console.debug({ cbid: cb.cbid, args })
    this.port.postMessage({
      type: 'callback',
      args: { cbid: cb.cbid, args },
    })
  }

  // will be set in registerBasicLinks
  private static stateLinks: { [name: string]: new (b: Bridge) => StateLink } = {}
  static registerStateLink(name: string, linkConstructor: new (b: Bridge) => StateLink) {
    this.stateLinks[name] = linkConstructor
  }

  static fromMessage(ev1: MessageEvent) {
    if (!safeOrigin(ev1)) {
      return
    }
    switch (ev1.data.type) {
      case 'hscmap/jupyter/handshake': {
        const port: MessagePort = ev1.data.port
        new Bridge(port)
      }
    }
  }
}

registerBasicLinks()
